import superagent from 'superagent'
import * as c from '../constants/actionTypes';
import * as config from '../config/config';

export function getAdminUserCollectionRequest() {
  return {
    type: c.GET_ADMINUSERCOLLECTION_REQUEST,
    loading: true
  }
}

export function getAdminUserCollectionSuccess(body) {
  return {
    type: c.GET_ADMINUSERCOLLECTION_SUCCESS,
    body: body,
    loading: false
  }
}

export function getAdminUserCollectionFailure(error) {
  return {
    type: c.GET_ADMINUSERCOLLECTION_FAILURE,
    error: error,
    loading: false
  }
}

export function getAdminUserCollection(page, cb) {
  var pager = (page)? '?page=' + page: '';
  return function(dispatch) {
    dispatch(getAdminUserCollectionRequest())
    superagent
    .get(config.BASE + 'api/admin/users'+pager)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert("Could not retrieve list of users")
        dispatch(getAdminUserCollectionFailure(err))
      } else {
        console.log("<---><---><---><--- ADMIN USER COLLECTION ><---><---><---><--->");
        console.log(res.body.length);
        console.log("<---><---><---><--- ADMIN USER COLLECTION ><---><---><---><--->");
        dispatch(getAdminUserCollectionSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

export function getAdminStudentCollectionRequest() {
  return {
    type: c.GET_ADMINSTUDENTCOLLECTION_REQUEST,
    loading: true
  }
}

export function getAdminStudentCollectionSuccess(body) {
  return {
    type: c.GET_ADMINSTUDENTCOLLECTION_SUCCESS,
    body: body,
    loading: false
  }
}

export function getAdminStudentCollectionFailure(error) {
  return {
    type: c.GET_ADMINSTUDENTCOLLECTION_FAILURE,
    error: error,
    loading: false
  }
}

export function getAdminStudentCollection(page, cb) {
  var pager = (page)? '?page=' + page: '';

  return function(dispatch) {
    console.log("inside ><---><---><---><--->");
    dispatch(getAdminUserCollectionRequest())
    superagent
    .get(config.BASE + 'api/admin/students'+ pager)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        dispatch(getAdminStudentCollectionFailure(err))
      } else {
        console.log("<---><---><---><--- ADMIN STUDENT COLLECTION ><---><---><---><--->");
        console.log(res.body.length);
        console.log("<---><---><---><--- ADMIN STUDENT COLLECTION ><---><---><---><--->");
        dispatch(getAdminStudentCollectionSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/AdminUserCollection.js